import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
} from '@mui/material';
import { useNavigate } from 'react-router-dom'; 
import BusinessIcon from '@mui/icons-material/Business';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from 'axios';
import { KeyUri } from '../key';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationBell from './NotificationBell';

const vendorToken = localStorage.getItem('vendorToken') || null;

export function VendorHeader({onMenuClick}) {
   const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [companyName, setCompanyName] = useState("Vendor Partner");
  const open = Boolean(anchorEl);

   useEffect(() => {
    async function fetchVendorInfo() {
      if (!vendorToken) return;
      try {
        
        const res = await axios.get(`${KeyUri.BACKEND_URI}/vendor/profile`, {
          headers: { Authorization: `Bearer ${vendorToken}` },
        });
     

    if (res.data?.vendor?.companyName) {
      setCompanyName(res.data.vendor.companyName);
    }
  

      } catch (error) {
        console.error("Failed to fetch vendor info:", error);
      }
    }
    fetchVendorInfo();
  }, []);

  // Where a clicked notification should take the vendor.
  // Adjust these routes to match your vendor app.
  const handleNotificationClick = (n) => {
    const entity = n.relatedEntity;
    if (entity?.type === 'property' && entity.id) {
      navigate(`/property/${entity.id}`);
    }
  };

   const handleProfileClick = () => {
    navigate('/vendor/profile');
    handleMenuClose();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


const handleLogout = async () => {
  try {
   
    const token = localStorage.getItem('vendorToken');
    if (token) {
      await axios.post(`${KeyUri.BACKEND_URI}/vendor/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      }).catch(err => console.log('Logout API optional:', err)); 
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
   
    localStorage.removeItem('vendorToken');
    navigate('/vendor/login');
    handleMenuClose();
  }
};


  return (
    <AppBar position="sticky" color="default" elevation={1} sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1.5, sm: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.1, sm: 1.5 } }}>
            <IconButton
            edge="start"
            color="inherit"
            sx={{ display: { xs: 'inline-flex', md: 'none' }, mr: 1 }}
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>
          <BusinessIcon
  color="primary"
  sx={{ fontSize: { xs: '1.6rem', sm: '2rem' } }}  
/>

          <Box>
            <Typography variant="h6" color="textPrimary" fontWeight={700} sx={{ fontSize: { xs: '0.95rem', sm: '1.25rem' } }}>
              Vendor Portal
            </Typography>
           <Typography
  variant="body2"
  color="textSecondary"
  sx={{
    lineHeight: 1,
    display: { xs: 'none', sm: 'block' }, 
  }}
>
  Travel & Hospitality Management
</Typography>

          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center',  gap: { xs: 0.5, sm: 2 }, }}>
          <NotificationBell baseUrl={KeyUri.BACKEND_URI} onItemClick={handleNotificationClick} />

          <IconButton
            onClick={handleMenuOpen}
            size="small"
            sx={{ ml: { xs: 0, sm: 2 } }} 
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            color="inherit"
          >
            <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}>
  {companyName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()}
</Avatar>
            <Box sx={{ ml: 1, display: { xs: 'none', sm: 'block' }, textAlign: 'left' }}>
              <Typography variant="body2" fontWeight={600}>
                {companyName}
              </Typography>
              <Typography variant="caption" sx={{ bgcolor: 'grey.300', px: 1, borderRadius: 1, color: 'text.secondary' }}>
                Active
              </Typography>
            </Box>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            PaperProps={{
              elevation: 3,
              sx: {
                width: 240,
                mt: 1.5,
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <Typography sx={{ px: 2, pt: 1, pb: 0.5, fontWeight: 700 }}>My Account</Typography>
            <Divider />
          <MenuItem onClick={handleProfileClick}>
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              Profile Settings
            </MenuItem>
            {/*<MenuItem>
              <ListItemIcon>
                <AccountBalanceIcon fontSize="small" />
              </ListItemIcon>
              Business Details
            </MenuItem>*/}
            <Divider />
           <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
  <ListItemIcon>
    <LogoutIcon fontSize="small" color="error" />
  </ListItemIcon>
  Logout
</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}